import React, { useState, useEffect } from 'react';
import usePageMeta from '../hooks/usePageMeta';
import './Gallery.css';

const categories = ['All', 'Apparel', 'Promotional', 'Engraving', 'Events'];

const galleryItems = [
  { src: '/gallery/gallery-01-tesla-shirts.webp', title: 'Custom Safety Shirts', category: 'Apparel' },
  { src: '/gallery/gallery-02-printing.webp', title: 'Screen Printing', category: 'Apparel' },
  { src: '/gallery/gallery-03-sara-fans.webp', title: 'Custom Fans', category: 'Promotional' },
  { src: '/gallery/gallery-04-fiesta.webp', title: 'Fiesta Event Shirts', category: 'Events' },
  { src: '/gallery/gallery-05-laser-engraving.webp', title: 'Laser Engraving', category: 'Engraving' },
  { src: '/gallery/gallery-06-IMG_5891.webp', title: 'Branded Apparel', category: 'Apparel' },
  { src: '/gallery/gallery-07-IMG_6057.webp', title: 'Custom Products', category: 'Promotional' },
  { src: '/gallery/gallery-08-IMG_6048.webp', title: 'Event Merchandise', category: 'Events' },
  { src: '/gallery/gallery-09-view-recent.webp', title: 'Recent Work', category: 'Promotional' },
  { src: '/gallery/gallery-10-IMG_6053.webp', title: 'Custom Designs', category: 'Apparel' },
  { src: '/gallery/gallery-11-IMG_6051.webp', title: 'Branded Merchandise', category: 'Promotional' },
];

function Gallery() {
  usePageMeta({
    title: 'Gallery — Custom Apparel & Promotional Product Portfolio',
    description: "Browse Heaven Sent's portfolio of custom apparel, embroidered logos, screen printing, banners, laser engraving, and promotional products for San Antonio businesses, schools, and events.",
    path: '/gallery',
  });
  const [activeCategory, setActiveCategory] = useState('All');
  const [lightbox, setLightbox] = useState(null);

  const filtered = activeCategory === 'All' ? galleryItems : galleryItems.filter(i => i.category === activeCategory);

  // ESC key closes the lightbox
  useEffect(() => {
    if (!lightbox) return;
    const handleEsc = (e) => { if (e.key === 'Escape') setLightbox(null); };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [lightbox]);

  return (
    <main className="gallery-page">
      <section
        className="page-hero"
        style={{
          backgroundImage:
            "linear-gradient(135deg, rgba(20, 12, 16, 0.55) 0%, rgba(40, 18, 28, 0.35) 60%, rgba(60, 25, 40, 0.45) 100%), url('/images/gallery-banner.webp')",
        }}
      >
        <h1 className="script-font">Our Gallery</h1>
        <p>Browse our work and see the quality we deliver</p>
      </section>

      <section className="gallery-section">
        <div className="gallery-filters">
          {categories.map(cat => (
            <button key={cat} className={`filter-btn ${activeCategory === cat ? 'active' : ''}`} onClick={() => setActiveCategory(cat)}>{cat}</button>
          ))}
        </div>

        <div className="gallery-grid">
          {filtered.map((item, i) => (
            <div key={i} className="gallery-item" onClick={() => item.src && setLightbox(item)}>
              {item.src ? (
                <img src={item.src} alt={item.title} loading="lazy" />
              ) : (
                <div className="gallery-placeholder">
                  
                  <span className="placeholder-text">{item.title}</span>
                </div>
              )}
              <div className="gallery-overlay">
                <span className="gallery-category">{item.category}</span>
                <h3>{item.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Lightbox */}
      {lightbox && (
        <div className="lightbox" onClick={() => setLightbox(null)}>
          <div className="lightbox-content" onClick={e => e.stopPropagation()}>
            <button className="lightbox-close" onClick={() => setLightbox(null)}>&times;</button>
            <img src={lightbox.src} alt={lightbox.title} />
            <div className="lightbox-info">
              <span className="gallery-category">{lightbox.category}</span>
              <h3>{lightbox.title}</h3>
            </div>
          </div>
        </div>
      )}
    </main>
  );
}

export default Gallery;
